export async function runUserModalMutationFlow({
  execute,
  onSuccess,
  reloadUsers,
  shouldReloadUsers = true,
}) {
  const result = await execute();
  if (!result?.success) {
    return { ok: false, result };
  }
  if (shouldReloadUsers && typeof reloadUsers === 'function') {
    await reloadUsers();
  }
  if (typeof onSuccess === 'function') {
    onSuccess(result);
  }
  return { ok: true, result };
}
